export const SUBSCRIPTION_NEEDED = 'SUBSCRIPTION_NEEDED'

export const subscriptionNeeded = (payload = true) => (dispatch, getState) => {
  const whitelist = ['/admin/', '/admin/account', '/admin/account/billing']
  dispatch({ type: SUBSCRIPTION_NEEDED, payload })
}
